<template>
  <div class="factory-pdf-export-wrapper">
    <div :id="contentId" class="factory-production-pdf-container">
    <template v-if="batchPageChunks.length <= 1">
      <div class="factory-production-pdf-page">
        <div class="factory-pdf-header-section">
          <div class="factory-pdf-header">
            <div class="factory-pdf-header-left">
              <div class="factory-pdf-logo-box"><img :src="jfLogo" alt="logo" class="factory-pdf-logo" /></div>
              <div class="factory-pdf-header-text">
                <div class="factory-pdf-company-row"><div class="factory-pdf-company-name">江丰集团</div><div class="factory-pdf-order-tag factory-pdf-order-tag--wide">内容变更单</div></div>
                <div class="factory-pdf-order-info"><span style="color: #000; font-weight: bold">销售单号 &nbsp;&nbsp;</span><span class="factory-pdf-strong-text">{{ item.contractCode || '/' }}</span></div>
              </div>
            </div>
            <div class="factory-pdf-header-right"><span class="factory-pdf-page-info">第1页/共1页</span></div>
          </div>
          <div class="factory-pdf-base-info">
            <div class="factory-pdf-base-row">
              <div class="factory-pdf-base-item"><span class="label">项目名称</span><span class="value">{{ item.contractName || item.project || '/' }}</span></div>
              <div class="factory-pdf-base-item factory-pdf-base-item-time"><span class="label">导出时间</span><span class="value">{{ exportTime }}</span></div>
            </div>
            <div class="factory-pdf-base-row">
              <div class="factory-pdf-base-item"><span class="label">业务员</span><span class="value">{{ item.business || item.salesmanName || '/' }}</span></div>
              <div class="factory-pdf-base-item factory-pdf-base-item-time"><span class="label">变更时间</span><span class="value">{{ formatNoticeTime(item.createTime) || '/' }}</span></div>
            </div>
            <div class="factory-pdf-base-row">
              <div class="factory-pdf-base-item"><span class="label">项目类型</span><span class="value">{{ item.projectType || '/' }}</span></div>
              <div class="factory-pdf-base-item factory-pdf-base-item-time" />
            </div>
          </div>
        </div>
        <div class="factory-pdf-table-wrapper">
          <table class="factory-pdf-table">
            <thead>
              <tr>
                <th style="width: 55px">项次</th>
                <th style="width: 120px" class="factory-pdf-text-left">批号/时间</th>
                <th style="width: 180px" class="factory-pdf-text-left">产品信息</th>
                <th style="width: 150px" class="factory-pdf-text-left">工艺</th>
                <th style="width: 90px" class="factory-pdf-text-left">尺寸</th>
                <th style="width: 70px">预定交期</th>
                <th style="width: 80px">总数</th>
              </tr>
            </thead>
            <tbody class="factory-pdf-product-row-group">
              <tr class="factory-pdf-product-main-row">
                <td class="text-center">1</td>
                <td class="factory-pdf-text-left">
                  <template v-if="!item.multipleAggregated">
                    <div>{{ item.batch || '/' }}</div>
                    <div v-if="item.productionAssignStartTime" class="factory-pdf-sub-text">{{ formatIntDate(item.productionAssignStartTime) || '/' }}</div>
                  </template>
                  <template v-else>
                    <template v-if="item.aggregatedBatches && item.aggregatedBatches.length">
                      <div v-for="(b, bi) in item.aggregatedBatches" :key="bi" class="batch-group">
                        <div>{{ b.batch || '/' }}</div>
                        <div v-if="b.productionAssignStartTime" class="factory-pdf-sub-text">{{ formatIntDate(b.productionAssignStartTime) || '/' }}</div>
                      </div>
                    </template>
                  </template>
                </td>
                <td class="factory-pdf-text-left">{{ item.productCode || '/' }}<div>{{ item.productName || '/' }}</div><div>{{ item.syscode || '/' }}</div></td>
                <td class="factory-pdf-text-left"><div>{{ item.typeOf || '/' }}</div><template v-if="productionNodes.length">{{ productionNodes.join(' / ') }}</template><template v-else>/</template></td>
                <td class="factory-pdf-text-left"><template v-if="displaySizeLines.length"><div v-for="sizeLine in displaySizeLines" :key="sizeLine">{{ sizeLine }}</div></template><template v-else>/</template></td>
                <td class="text-center">
                  <template v-if="!item.multipleAggregated">{{ formatIntDate(item.deliveryTime) || '/' }}</template>
                  <template v-else><div v-for="(b, bi) in item.aggregatedBatches" :key="bi" class="batch-group"><div>{{ formatIntDate(b.deliveryTime) || '/' }}</div></div></template>
                </td>
                <td class="text-center">{{ item.newCount != null && item.newCount !== '' ? item.newCount : '/' }}</td>
              </tr>
              <tr><td colspan="7" class="factory-pdf-product-desc-cell">{{ item.productDescription || item.description || '/' }}</td></tr>
              <tr><td colspan="7" class="factory-pdf-product-desc-cell" style="color: #D2475D;text-align: left;"><span style="font-weight: bold;">申请人:</span> {{ initiatorName || '/' }}</td></tr>
              <tr><td colspan="7" class="factory-pdf-product-desc-cell" style="color: #D2475D;text-align: left;"><span style="font-weight: bold;">变更内容:</span><template v-if="changeDetailLines.length"><div v-for="(line, li) in changeDetailLines" :key="li">{{ line }}</div></template><template v-else>/</template></td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
    <template v-else>
    <div v-for="(chunk, pageIdx) in batchPageChunks" :key="pageIdx" class="factory-production-pdf-page">
      <div class="factory-pdf-header-section">
        <div class="factory-pdf-header">
          <div class="factory-pdf-header-left">
            <div class="factory-pdf-logo-box"><img :src="jfLogo" alt="logo" class="factory-pdf-logo" /></div>
            <div class="factory-pdf-header-text">
              <div class="factory-pdf-company-row"><div class="factory-pdf-company-name">江丰集团</div><div class="factory-pdf-order-tag factory-pdf-order-tag--wide">内容变更单</div></div>
              <div class="factory-pdf-order-info"><span style="color: #000; font-weight: bold">销售单号 &nbsp;&nbsp;</span><span class="factory-pdf-strong-text">{{ item.contractCode || '/' }}</span></div>
            </div>
          </div>
          <div class="factory-pdf-header-right"><span class="factory-pdf-page-info">第{{ pageIdx + 1 }}页/共{{ batchPageChunks.length }}页</span></div>
        </div>
        <div class="factory-pdf-base-info">
          <div class="factory-pdf-base-row">
            <div class="factory-pdf-base-item"><span class="label">项目名称</span><span class="value">{{ item.contractName || item.project || '/' }}</span></div>
            <div class="factory-pdf-base-item factory-pdf-base-item-time"><span class="label">导出时间</span><span class="value">{{ exportTime }}</span></div>
          </div>
          <div class="factory-pdf-base-row">
            <div class="factory-pdf-base-item"><span class="label">业务员</span><span class="value">{{ item.business || item.salesmanName || '/' }}</span></div>
            <div class="factory-pdf-base-item factory-pdf-base-item-time"><span class="label">变更时间</span><span class="value">{{ formatNoticeTime(item.createTime) || '/' }}</span></div>
          </div>
          <div class="factory-pdf-base-row">
            <div class="factory-pdf-base-item"><span class="label">项目类型</span><span class="value">{{ item.projectType || '/' }}</span></div>
            <div class="factory-pdf-base-item factory-pdf-base-item-time" />
          </div>
        </div>
      </div>
      <div class="factory-pdf-table-wrapper">
        <table class="factory-pdf-table">
          <thead>
            <tr>
              <th style="width: 55px">项次</th>
              <th style="width: 120px" class="factory-pdf-text-left">批号/时间</th>
              <th style="width: 180px" class="factory-pdf-text-left">产品信息</th>
              <th style="width: 150px" class="factory-pdf-text-left">工艺</th>
              <th style="width: 90px" class="factory-pdf-text-left">尺寸</th>
              <th style="width: 70px">预定交期</th>
              <th style="width: 80px">总数</th>
            </tr>
          </thead>
          <tbody class="factory-pdf-product-row-group">
            <tr class="factory-pdf-product-main-row">
              <td class="text-center">1</td>
              <td class="factory-pdf-text-left">
                <div v-for="(b, bi) in chunk" :key="bi" class="batch-group">
                  <div>{{ b.batch || '/' }}</div>
                  <div v-if="b.productionAssignStartTime" class="factory-pdf-sub-text">{{ formatIntDate(b.productionAssignStartTime) || '/' }}</div>
                </div>
              </td>
              <td class="factory-pdf-text-left">{{ item.productCode || '/' }}<div>{{ item.productName || '/' }}</div><div>{{ item.syscode || '/' }}</div></td>
              <td class="factory-pdf-text-left"><div>{{ item.typeOf || '/' }}</div><template v-if="productionNodes.length">{{ productionNodes.join(' / ') }}</template><template v-else>/</template></td>
              <td class="factory-pdf-text-left"><template v-if="displaySizeLines.length"><div v-for="sizeLine in displaySizeLines" :key="sizeLine">{{ sizeLine }}</div></template><template v-else>/</template></td>
              <td class="text-center">
                <div v-for="(b, bi) in chunk" :key="bi" class="batch-group"><div>{{ formatIntDate(b.deliveryTime) || '/' }}</div></div>
              </td>
              <td class="text-center" v-if="pageIdx === 0">{{ item.newCount != null && item.newCount !== '' ? item.newCount : '/' }}</td>
              <td class="text-center" v-else></td>
            </tr>
            <template v-if="pageIdx === batchPageChunks.length - 1">
            <tr><td colspan="7" class="factory-pdf-product-desc-cell">{{ item.productDescription || item.description || '/' }}</td></tr>
            <tr><td colspan="7" class="factory-pdf-product-desc-cell" style="color: #D2475D;text-align: left;"><span style="font-weight: bold;">申请人:</span> {{ initiatorName || '/' }}</td></tr>
            <tr>
              <td colspan="7" class="factory-pdf-product-desc-cell" style="color: #D2475D;text-align: left;">
                <span style="font-weight: bold;">变更内容:</span><template v-if="changeDetailLines.length"><div v-for="(line, li) in changeDetailLines" :key="li">{{ line }}</div></template><template v-else>/</template>
              </td>
            </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import jfLogo from '@/assets/jf.png'

type AnyRecord = Record<string, any>

const BATCHES_PER_PAGE = 16

const props = defineProps({
  item: { type: Object as () => AnyRecord, default: () => ({}) },
  contentId: { type: String, default: '' },
  formatNoticeTime: { type: Function as unknown as () => (dateStr: any) => string | undefined, required: true }
})

const item = computed(() => props.item)

const batchPageChunks = computed(() => {
  const batches = props.item?.aggregatedBatches
  if (!props.item?.multipleAggregated || !Array.isArray(batches) || batches.length === 0) {
    return []
  }
  const chunks: any[][] = []
  for (let i = 0; i < batches.length; i += BATCHES_PER_PAGE) {
    chunks.push(batches.slice(i, i + BATCHES_PER_PAGE))
  }
  return chunks
})

const formatIntDate = (date: string | number | undefined) => {
  if (!date) return '/'
  const d = new Date(date)
  const year = d.getFullYear().toString().slice(-2)
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}/${parseInt(month)}/${parseInt(day)}`
}

const contentId = computed(() => props.contentId || 'content-change-cover-pdf-content')

const productionNodes = computed<string[]>(() => {
  const raw = props.item?.productionNode
  if (Array.isArray(raw)) return raw.filter((x) => typeof x === 'string' && x.trim())
  if (typeof raw === 'string') return raw.split(/[,/]/).map((x) => x.trim()).filter(Boolean)
  return []
})

const displaySizeLines = computed<string[]>(() => {
  const lines: string[] = []
  if (props.item?.width) lines.push(`W ${props.item.width}`)
  if (props.item?.depth) lines.push(`D ${props.item.depth}`)
  if (props.item?.height) lines.push(`H ${props.item.height}`)
  if (!lines.length && props.item?.productSize) lines.push(String(props.item.productSize))
  return lines
})

const exportTime = computed(() => {
  const now = new Date()
  const pad = (v: number) => String(v).padStart(2, '0')
  return `${now.getFullYear()}/${pad(now.getMonth() + 1)}/${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`
})

function formatPlainText(value: unknown): string {
  if (value == null) return ''
  return String(value).trim()
}

const initiatorName = computed(() => formatPlainText(props.item?.initiatorName))
const changeDetail = computed(() => formatPlainText(props.item?.changeDetail))
const changeDetailLines = computed(() => {
  const raw = changeDetail.value
  if (!raw) return [] as string[]
  const parts = raw.split(/[;；]/).map(s => s.trim()).filter(Boolean)
  const qtyParts = parts.filter(s => s.startsWith('数量'))
  const otherParts = parts.filter(s => !s.startsWith('数量'))
  return [...qtyParts, ...otherParts]
})

</script>

<style scoped lang="scss">
.factory-pdf-export-wrapper {
  position: fixed;
  left: -99999px;
  top: 0;
  z-index: -1;
  pointer-events: none;
}

.factory-production-pdf-container {
  width: 794px;
  background: #ffffff;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  color: #000;
}

.factory-production-pdf-page {
  width: 100%;
  height: 1123px;
  box-sizing: border-box;
  padding: 24px 24px 16px 24px;
  page-break-after: always;
  page-break-inside: avoid;
  break-after: page;
  break-inside: avoid;
}

.factory-production-pdf-page:last-child {
  page-break-after: auto;
  break-after: auto;
}

.factory-pdf-header-section {
  background-image: url('@/assets/pdfTop.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 16px 16px 8px 16px;
  margin: -8px -8px 0px -8px;
  border-radius: 4px;
}

.factory-pdf-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.factory-pdf-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.factory-pdf-logo-box {
  width: 48px;
  height: 48px;
}

.factory-pdf-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.factory-pdf-header-text {
  display: flex;
  flex-direction: column;
}

.factory-pdf-company-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.factory-pdf-company-name {
  font-size: 22px;
  font-weight: bold;
}

.factory-pdf-order-tag {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #000;
  font-size: 16px;
  color: #d2475d;
  font-weight: bold;
  line-height: 1;
  width: 96px;
  height: 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.factory-pdf-order-tag--wide {
  width: 104px;
}

.factory-pdf-order-info {
  font-size: 16px;
  color: #333;
}

.factory-pdf-strong-text {
  font-weight: 500;
}

.factory-pdf-header-right {
  font-size: 12px;
  color: #000;
}

.factory-pdf-base-info {
  border-radius: 4px;
  padding: 6px 10px;
  margin-bottom: 8px;
  font-size: 16px;
}

.factory-pdf-base-row {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 4px;
  &:last-child {
    margin-bottom: 0;
  }
}

.factory-pdf-base-item {
  display: flex;
  align-items: center;
  width: 50%;
  gap: 6px;
  &.factory-pdf-base-item-time {
    flex-shrink: 0;
  }
}

.factory-pdf-base-item .label {
  min-width: 58px;
  color: #000;
  font-weight: bold;
}

.factory-pdf-base-item .value {
  color: #3e3e3e;
}

.factory-pdf-table-wrapper {
  border-radius: 4px;
  border: 1px solid #000;
  overflow: hidden;
}

.factory-pdf-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 14px;
}

.factory-pdf-table th,
.factory-pdf-table td {
  padding: 4px 4px;
  text-align: center;
  vertical-align: middle;
}

.factory-pdf-table th.factory-pdf-text-left,
.factory-pdf-table td.factory-pdf-text-left {
  text-align: left;
}

.factory-pdf-table th:last-child,
.factory-pdf-table td:last-child {
  border-right: none;
}

.factory-pdf-table thead th {
  background-color: #eeeeee;
  height: 36px;
  font-weight: bold;
  border-bottom: 1px solid #000;
}

.factory-pdf-table tbody tr:last-child td {
  border-bottom: none;
}

.factory-pdf-table tbody.factory-pdf-product-row-group {
  height: 100px;
}

.factory-pdf-table tbody tr.factory-pdf-product-desc-row {
  border-bottom: 1px solid #000;
}

.factory-pdf-product-desc-cell {
  padding: 0px 8px 4px 8px !important;
  text-align: left !important;
  vertical-align: top !important;
  line-height: 1.2;
  word-break: break-word;
  word-wrap: break-word;
}

.factory-pdf-table td {
  line-height: 1.2;
}

.batch-group {
  padding-bottom: 4px;
  margin-bottom: 4px;
  border-bottom: 1px dashed #ccc;
}

.batch-group:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.factory-pdf-table td .factory-pdf-sub-text {
  font-size: 11px;
  color: #666;
  margin-top: 2px;
}
</style>
